import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageComponent } from '../components/message.component';
import { TranslatetionModule } from 'src/core/translation/modules/translation.module';


@NgModule({
  declarations: [
    MessageComponent,
    
  ],
  imports:[
    CommonModule,
    TranslatetionModule
  ],
  exports:[
    MessageComponent
  ]
})
export class MessageModule { }
